/**
 * Service for the article landing page template.
 *
 * @type {{init}}
 * @author Nick Galvez
 */
const articleService = (() => {
    /**
     * The article_tag taxonomy.
     * @type {string}
     */
    let filter = '';

    /**
     * The current landing page.
     * @type {string}
     */
    let landingPage = '';

    const $loadingElement = $('.article-grid__loading');
    const $articlesElement = $('.article-grid');

    function updateGrid() {
        const tiles = $(`#article-grid-container li[data-article-tags~='${filter}']`);

        $('#article-grid-container li').hide();
        tiles.show();
    }

    /**
     * Process a click on a filter button.
     * @param event
     *
     * @private
     */
    function updateFilter(event) {
        const selectedButton = $(event.target);

        if (selectedButton.data('filter-name') === filter) {
            // user clicked the same button. Don't reload.
            return;
        }

        $('.tag-button').removeClass('selected');
        // Update the landing page copy
        // $('.article-landing-text > h1').html(selectedButton.text());
        $('.article-landing-text > p').html(selectedButton.data('filter-description'));

        // Update the filter.
        filter = selectedButton.data('filter-name');
        selectedButton.addClass('selected');

        // write tag name to URL
        let filterURL;
        if (filter === '') {
            // if the filter button is the "show all" button, reset URL to have no filter
            filterURL = landingPage;
            window.history.pushState(filter, null, filterURL);
        } else {
            // all other buttons write the filter name to the URL
            filterURL = `${landingPage}filter/${filter}/`;
            window.history.pushState(filter, null, filterURL);
        }
        updateGrid();
    }

    /**
     * Attach event listeners to the DOM.
     * @private
     */
    function attachEvents() {
        window.ajaxEvent.attach('ajaxStart.articles', () => {
            $loadingElement.fadeIn('fast');
            $articlesElement.css({ opacity: '.2' });
        });
        window.ajaxEvent.attach('ajaxComplete.articles', () => {
            $loadingElement.fadeOut('fast');
            $articlesElement.css({ opacity: '1' });
        });

        // Clicks
        $('.tag-button').on('click', (event) => {
            updateFilter(event);
        });
    }

    /**
     * Init function. Called on load.
     * @private
     */
    function init() {
        // Get data passed from backend
        const dataDiv = $('#article-grid-container');

        // Set initial state.
        filter = dataDiv.data('article-tags');
        landingPage = dataDiv.data('landing-page');

        attachEvents();
        $loadingElement.fadeOut('fast');
        updateGrid();
    }

    /**
     * Public Function(s)
     *
     * @public
     */
    return {
        init,
    };
})();

$(document).ready(() => {
    articleService.init();
});
